import React from 'react'
import ReactDOM from 'react-dom/client'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import App from './components'
import reducer from './reducers'
import axios from 'axios';

import './App.scss';

const store = createStore(reducer);

axios.get('https://keithgd.com/survivor-data')
  .then((res) => {
    store.dispatch({
      type: 'INITIAL_SETUP',
      state: {
        winners: res.data.winners,
        losers: res.data.losers,
        remainingSurvivors: res.data.survivors,
        torchedSurvivors: [],
        activeTribalNumber: 0,
        totalTribalsCount: res.data.outOrder.length,
      },
      outOrder: res.data.outOrder,
    });
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
